import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule)
  },
  {
    path: 'unit-info',
    loadChildren: () => import('./unit-info/unit-info.module').then( m => m.UnitInfoPageModule)
  },
  {
    path: 'product',
    loadChildren: () => import('./product/product.module').then( m => m.ProductPageModule)
  },
  {
    path: 'cart',
    loadChildren: () => import('./cart/cart.module').then( m => m.CartPageModule)
  },
  {
    path: 'order',
    loadChildren: () => import('./order/order.module').then( m => m.OrderPageModule)
  },
  {
    path: 'set-delivery',
    loadChildren: () => import('./set-delivery/set-delivery.module').then( m => m.SetDeliveryPageModule)
  },
  {
    path: 'sign-in',
    loadChildren: () => import('./sign-in/sign-in.module').then( m => m.SignInPageModule)
  },
  {
    path: 'set-payment',
    loadChildren: () => import('./set-payment/set-payment.module').then( m => m.SetPaymentPageModule)
  },
  {
    path: 'open-table',
    loadChildren: () => import('./open-table/open-table.module').then( m => m.OpenTablePageModule)
  },
  {
    path: 'send-order',
    loadChildren: () => import('./send-order/send-order.module').then( m => m.SendOrderPageModule)
  },
  {
    path: 'check-order',
    loadChildren: () => import('./check-order/check-order.module').then( m => m.CheckOrderPageModule)
  },
  {
    path: 'orders/:id',
    loadChildren: () => import('./orders/orders.module').then(m => m.OrdersPageModule)
  },
  {
    path: 'order/:id',
    loadChildren: () => import('./order/order.module').then(m => m.OrderPageModule)
  },
  {
    path: 'start-page',
    loadChildren: () => import('./start-page/start-page.module').then( m => m.StartPagePageModule)
  },
  {
    path: '',
    redirectTo: '/start-page',
    pathMatch: 'full'
  },
  {
    path: 'units',
    loadChildren: () => import('./units/units.module').then( m => m.UnitsPageModule)
  },
  {
    path: 'start-counter-order',
    loadChildren: () => import('./start-counter-order/start-counter-order.module').then( m => m.StartCounterOrderPageModule)
  },
  {
    path: 'vouchers',
    loadChildren: () => import('./vouchers/vouchers.module').then( m => m.VouchersPageModule)
  },
  {
    path: 'available-rewards',
    loadChildren: () => import('./available-rewards/available-rewards.module').then( m => m.AvailableRewardsPageModule)
  },
  {
    path: 'points-program-regulation',
    loadChildren: () => import('./points-program-regulation/points-program-regulation.module').then( m => m.PointsProgramRegulationPageModule)
  },
  {
    path: 'points-program',
    loadChildren: () => import('./points-program/points-program.module').then( m => m.PointsProgramPageModule)
  },
  {
    path: 'voucher-details',
    loadChildren: () => import('./voucher-details/voucher-details.module').then( m => m.VoucherDetailsPageModule)
  }
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, useHash: true })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
